export default __webpack_public_path__ + "f8c7d635f464f1e96968191c21e8ad51.svg";